import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom';
import { fetchBlogs } from '../../api';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(4),
    maxHeight: 420,
    overflow: 'hidden',
    position: 'sticky',
    top: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(3),
  },
  post: {
    display: 'flex',
    marginBottom: theme.spacing(3),
    textDecoration: 'none',
  },
  postImage: {
    width: 80,
    height: 80,
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(2),
  },
  postContent: {
    flex: 1,
  },
  postDate: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  postTitle: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: 1.4,
    marginBottom: theme.spacing(1),
  },
  postExcerpt: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
}));

const RecentPosts = () => {
  const classes = useStyles();
  const [recentPosts, setRecentPosts] = React.useState([]);
  useEffect(() => {
    const load = async () => {
      const list = await fetchBlogs();
      const formatted = list
        .slice(0, 3)
        .map((b) => ({
          id: b.id,
          slug: b.slug || b.id,
          date: b.date ? new Date(b.date).toLocaleDateString() : '',
          title: b.title || b.heading,
          excerpt:
            (b.excerpt || b.description || '').slice(0, 120) +
            ((b.excerpt || b.description || '').length > 120 ? '...' : ''),
          image: b.image || b.imageUrl || '/placeholder.png',
        }));
      setRecentPosts(formatted);
    };
    load();
  }, []);

  return (
    <Box className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        Similar Blogs
      </Typography>
      {recentPosts.map((post) => (
        <Link to={`/blogs/${post.slug}`} key={post.id} className={classes.post}>
          <img
            src={post.image}
            alt={post.title}
            className={classes.postImage}
          />
          <Box className={classes.postContent}>
            <Typography className={classes.postDate}>{post.date}</Typography>
            <Typography className={classes.postTitle}>{post.title}</Typography>
            <Typography className={classes.postExcerpt}>
              {post.excerpt}
            </Typography>
          </Box>
        </Link>
      ))}
    </Box>
  );
};

export default RecentPosts;
